/**
 *
 * Asynchronously loads the component for Pratica
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./app/containers/Pratiche/Loadable.js